import { FunctionComponent, useEffect } from "react";
import { DashboardModel, useGetDashboardModel } from "@sisense/sdk-ui";

export interface GetWidgetModelProps {
  dashboardOid: string;
  exitComponent: (dashboardModel?: DashboardModel | Error) => void;
}

export const GetDashboardModel: FunctionComponent<GetWidgetModelProps> = ({
  dashboardOid,
  exitComponent,
}) => {
  const { dashboard, error } = useGetDashboardModel({ dashboardOid });

  useEffect(() => {
    if (dashboard || error) {
      exitComponent(dashboard || error);
    }
  }, [dashboard, exitComponent, error]);

  return null;
};
